<template>
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17028_33657)">
      <path
        d="M9.76331 2.51903L1.5101 10.7728C1.46858 10.8145 1.43859 10.8671 1.42432 10.9236L0.509528 14.5954C0.482164 14.7059 0.514644 14.8234 0.595309 14.9041C0.656342 14.9651 0.739505 14.9989 0.824571 14.9989C0.850626 14.9989 0.877277 14.9957 0.903213 14.9892L4.57498 14.0742C4.63221 14.06 4.6842 14.0301 4.72572 13.9886L12.9796 5.73537L9.76331 2.51903Z"
        fill="#153D49"
      />
      <path
        d="M15.0243 1.39366L14.1056 0.474943C13.4916 -0.139081 12.4214 -0.138486 11.8081 0.474943L10.6827 1.60032L13.899 4.81654L15.0243 3.69116C15.331 3.38457 15.5 2.97649 15.5 2.54247C15.5 2.10845 15.331 1.70037 15.0243 1.39366Z"
        fill="#153D49"
      />
    </g>
    <defs>
      <clipPath id="clip0_17028_33657">
        <rect width="15" height="15" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
